"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _utils = require("../utils");
function getParent(item, allOptions, valueKey) {
  return (0, _lodash.find)(allOptions, function (o) {
    return (0, _utils.hasChildren)(o) && (0, _lodash.findIndex)(o.children, function (child) {
      return child[valueKey] === item[valueKey];
    }) >= 0;
  });
}
var _default = exports["default"] = getParent;